import { HiCheckCircle } from 'react-icons/hi/index.esm';

const ChangePasswordSuccess = () =>
  <div className="flex flex-col items-center justify-center gap-5 pt-6">
    <HiCheckCircle size={70} className="text-green-50" />
    <h3 className="text-center">You have successfully changed your password</h3>
  </div>;

export default ChangePasswordSuccess;
